var _defs, _path, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWmuLockupWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 620 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "hash"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 128,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "black",
    strokeWidth: 7,
    strokeLinecap: "round",
    transform: "rotate(-4 50 46)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 28,
    x2: 41,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 28,
    x2: 57,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 39,
    x2: 70,
    y2: 39
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 53,
    x2: 68,
    y2: 53
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    mask: "url(#hash)",
    d: "M50 4 C24.5 4 6 23.5 6 47.5 C6 77 44 116 50 122 C56 116 94 77 94 47.5 C94 23.5 75.5 4 50 4 Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 86,
    fontFamily: "Figtree, Inter, -apple-system, sans-serif",
    fontWeight: 600,
    fontSize: 62,
    letterSpacing: -1.5,
    fill: "#FFFFFF"
  }, "what's my uprn", /*#__PURE__*/React.createElement("tspan", {
    fill: "#2ED9C3"
  }, "?"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWmuLockupWhite);
export default __webpack_public_path__ + "static/media/wmu-lockup-white.5320022ad32a740c63fac5fd99e24819.svg";
export { ForwardRef as ReactComponent };